export default {
    common: {
        home: 'Accueil',
        mainMenu: 'Menu principal',
        inbox: 'Ma boîte de réception',
        requests: 'Demandes',
        reports: 'Rapports',
        settings: 'Paramètres',
        accesses: 'Accès',
        flowAdmin: 'Administration du flux',
        states: 'États',
        documents: 'Documents',
        reviewers: 'Réviseurs',
        close: 'Fermer',
        save: 'Enregistrer',
        edit: 'Modifier',
        delete: 'Supprimer',
        detail: 'Détail',
        actions: 'Actions',
        status: 'Statut',
        value: 'Valeur',
        area: 'Zone',
        creatorUser: 'Créé par',
        search: 'Rechercher',
        comments: 'Commentaires',
        yes: 'Oui',
        no: 'Non',
        loading: 'Chargement...',
        saving: 'Enregistrement...',
        requiredField: 'Ce champ est requis',
        requiredOption: 'Sélectionnez une option',
        na: 'N/A'
    },
    menu: {
        report1: 'Rapport 1',
        report2: 'Rapport 2',
        dashboardReport: 'Rapport du tableau de bord'
    },
    solicitud: {
        title: 'Demande de Memorandum of Agreement',
        registerRequest: 'Enregistrer la demande',
        createRequest: 'Créer une demande',
        updateRequest: 'Mettre à jour la demande',
        requestDetail: 'Détail de la demande',
        generalInfo: 'Informations générales',
        processInfo: 'Informations du processus',
        attachments: 'Pièces jointes',
        tracking: 'Suivi',
        trackingProcess: 'Suivi du processus',
        trackingList: 'Liste de suivi',
        registerComment: 'Enregistrer un commentaire',
        timeline: 'Chronologie',
        reviewers: 'Réviseurs',
        titleField: 'Titre',
        project: 'Projet',
        grant: 'Subvention',
        amount: 'Montant',
        object: 'Objet',
        donor: 'Donateur',
        responsible: 'Responsable',
        implementingPartner: 'Partenaire de mise en œuvre',
        additionalComments: 'Commentaires supplémentaires',
        requestDate: 'Date de la demande',
        recordDate: 'Date d’enregistrement',
        consecutive: 'Consécutif',
        creatorArea: 'Créateur / Zone',
        registerCommentBtn: 'Enregistrer le commentaire',
        saveDraft: 'Enregistrer le brouillon',
        draftSaved: 'Brouillon enregistré avec succès',
        requestSaved: 'Demande enregistrée avec succès',
        commentSaved: 'Commentaire enregistré avec succès',
        saveError: 'Erreur lors de l’enregistrement de la demande.',
        commentSaveError: 'Erreur lors de l’enregistrement du commentaire.',
        deleteConfirmTitle: 'Confirmer la suppression',
        deleteConfirmText: 'Êtes-vous sûr de vouloir supprimer cet enregistrement ?',
        editTooltip: 'Modifier',
        detailTooltip: 'Détail',
        deleteTooltip: 'Supprimer',
        approvedRequest: 'Demande approuvée',
        noActionsAvailable: 'Aucune action disponible pour ce statut.',
        attachAgreement: 'Joindre le Memorandum of Agreement',
        observations: 'Observations',
        user: 'Utilisateur',
        from: 'De',
        result: 'Résultat',
        initialState: 'Statut initial',
        finalState: 'Statut final',
        date: 'Date',
        bp: 'BP',
        unitedId: 'ID Nations Unies',
        validationDate: 'Date de validation',
        applicationFrom: 'Numéro Application From',
        agreementNumber: 'Numéro d’accord',
        policyAttach: 'Joindre la politique',
        receiptAttach: 'Joindre le reçu de paiement',
        maAttach: 'Joindre MA',
        fields: {
            searchLabel: 'Rechercher par titre et/ou numéro consécutif'
        },
        validations: {
            draftMin: 'Pour enregistrer un brouillon, vous devez saisir au moins le titre et le montant.',
            attachAgreementRequired: 'Vous devez joindre le Memorandum of Agreement.',
            actionObservationRequired: 'Vous devez saisir des observations pour cette action.',
            bpUnitedDateRequired: 'Vous devez saisir BP, ID Nations Unies et la date de validation pour approuver.',
            returnObservationRequired: 'Vous devez saisir des observations pour retourner.',
            returnFieldsEmpty: 'Pour retourner, BP / ID Nations Unies / Date de validation doivent être vides.',
            applicationFromRequired: 'Vous devez saisir le numéro Application From.',
            agreementRequired: 'Vous devez saisir le numéro d’accord.',
            stateApprovedNeedBp: 'BP est requis lorsque la demande est approuvée',
            stateApprovedNeedUnited: 'ID Nations Unies requis lorsque la demande est approuvée',
            stateApprovedNeedDate: 'Date de validation requise lorsque la demande est approuvée',
            requiredPolicy: 'La politique est requise',
            requiredReceipt: 'Le reçu de paiement est requis',
            requiredMA: 'MA est requis'
        },
        actions: {
            approve: 'Approuver',
            send: 'Envoyer',
            create: 'Créer',
            finish: 'Terminer',
            liquidate: 'Liquider',
            return: 'Retourner',
            reject: 'Rejeter',
            cancel: 'Annuler'
        },
        results: {
            canceled: 'Annulé',
            request: 'Demande',
            received: 'Reçu',
            comment: 'Commentaire',
            finished: 'Terminé',
            returned: 'Retourné',
            code: 'Code'
        },
        excelHeaders: {
            actions: 'Actions',
            status: 'Statut',
            consecutive: 'Consécutif',
            title: 'Titre',
            requestDate: 'Date de demande',
            value: 'Montant',
            grant: 'Subvention',
            area: 'Zone',
            creatorUser: 'Créé par'
        }
    }
}